import { Col, Row, FloatButton, Checkbox, Space, Button } from "antd-v5";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EqButton from "../../eqButton/EqButton";
import RevealList from "../../RevealList/RevealList";
import "../EqProductRequests.scss";
import EqCollapse from "../../eqCollapse/EqCollapse";
import { EqCurrency, ProductOrderStatus } from "../../../shared/enums";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { IProductOPtions } from "../../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";

interface RequestWidgetProps {
    data: any[]; // Replace 'any' with the actual type of your product invite
    onAccept: (requestId: string) => void;
    OnReject: (requestId: string) => void;
    multipleSelect?: boolean;
    OnRejectMultiple?: (requestIds: string[]) => void;
    OnAcceptMultiple?: (requestIds: string[]) => void;
}

const RequestWidget: React.FC<RequestWidgetProps> = ({
    data,
    onAccept,
    OnReject,
    multipleSelect,
    OnRejectMultiple,
    OnAcceptMultiple
}) => {
    const { t, i18n } = useTranslation();

    const [filteredProductRequests, setFilteredProductRequests] = useState() as any;

    const [selectedCheckboxes, setSelectedCheckboxes] = useState([] as any);
    const [isCheckAll, setIsCheckAll] = useState(false);

   
    useEffect(() => {
        if (data) {
            setFilteredProductRequests(data);
        }
    }, [data]);

    const checkAll = () => {
        const isChecked = !isCheckAll;

        setFilteredProductRequests((prevOrders: any) => {
            const updatedList = prevOrders.map((order: any) => ({
                ...order,
                selected: isChecked,
            }));

            setIsCheckAll(isChecked);
            const updatedSelectedCheckboxes = updatedList.filter(
                (x: any) => x.selected
            );
            setSelectedCheckboxes(updatedSelectedCheckboxes);

            return updatedList;

        });
    };


    const handleOnCheck = (order: any) => {

        setFilteredProductRequests((prevOrders: any) => {
            const list = [...prevOrders];
            const updatedList = list.map((item) =>
                item.id === order.id ? { ...item, selected: !item.selected } : item
            );
            const updatedSelectedCheckboxes = updatedList.filter((x) => x.selected);
            setSelectedCheckboxes(updatedSelectedCheckboxes);

            return updatedList;
        });
    };

    const handleMultipleReject = () => {
        const selectedInviteIds = selectedCheckboxes.map(
            (invite: any) => invite.id
        );

        OnRejectMultiple && OnRejectMultiple(selectedInviteIds)
        setSelectedCheckboxes([])
    };


    const handleMultipleAccept = () => {
        const selectedInviteIds = selectedCheckboxes.map(
            (invite: any) => invite.id
        );

        OnAcceptMultiple && OnAcceptMultiple(selectedInviteIds)
        setSelectedCheckboxes([])

    };


    return (
        <div className="eqProductRequest">
            <Row>

                <Col span={24}>
                    <Row justify="end" className="action-all-btn hidden-sm">
                        {selectedCheckboxes.length > 1 && (
                            <div className="float-btn">
                                {/* <Space > */}


                                <FloatButton
                                    className="accept-btn"
                                    description={t("acceptAll")}
                                    shape="square"
                                    onClick={() => handleMultipleAccept()}
                                />
                                <FloatButton
                                    className="reject-btn"
                                    description={t("rejectAll")}
                                    shape="square"
                                    onClick={() => handleMultipleReject()}
                                />
                                {/* </Space> */}
                            </div>
                        )}
                    </Row>
                </Col>

                <Col span={24}>
                    <Row className="eq-fl-row hidden-sm">
                        {multipleSelect &&
                            <Col className="eq-fl-th " span={2}>
                                <Checkbox onChange={checkAll} checked={isCheckAll}></Checkbox>
                            </Col>
                        }
                        <Col span={2}>{t("number")} </Col>
                        <Col className="eq-fl-th" span={5}>
                            {t("student")}
                        </Col>
                        <Col className="eq-fl-th" span={6}>
                            {t("title")}
                        </Col>

                        <Col className="eq-fl-th" span={5}>
                            {t("amount")}
                        </Col>
                        <Col className="eq-fl-th" span={4}>
                            {t("actions")}
                        </Col>
                    </Row>
                    <Row justify="space-between" className="eq-fl-row hidden-md">
                        {multipleSelect &&
                            <Col className="eq-fl-th">
                                <Checkbox onChange={checkAll} checked={isCheckAll}>
                                    {" "}
                                    Check all
                                </Checkbox>
                            </Col>
                        }
                        <Col>
                            <Row justify="end" className="action-delete-all">
                                {selectedCheckboxes.length > 1 && (
                                    <>
                                        <EqButton onClick={() => handleMultipleAccept()}>
                                            {t("acceptAll")}
                                        </EqButton>
                                        <EqButton onClick={() => handleMultipleReject()}>
                                            {t("rejectAll")}
                                        </EqButton>
                                    </>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <RevealList>
                        <Row className="">
                            {filteredProductRequests?.map(
                                (productOrder: any, index: number) => (
                                    <div className="product-invite">
                                        <Row className="eq-f-row hidden-sm">
                                            {multipleSelect &&
                                                <Col className="eq-f-td" span={2}>
                                                    <Checkbox
                                                        onChange={() => {
                                                            handleOnCheck(productOrder);
                                                        }}
                                                        checked={productOrder.selected}
                                                    ></Checkbox>
                                                </Col>
                                            }
                                            <Col span={2}>{index + 1}</Col>
                                            <Col className="eq-fl-th" span={5}>
                                                {`${productOrder.student.firstName}  ${productOrder.student.lastName}`}
                                            </Col>
                                            <Col className="eq-f-td" span={6}>
                                                {productOrder.product.title}
                                            </Col>

                                            <Col className="eq-fl-th" span={5}>
                                                {productOrder.product.price + " "}
                                                {EqCurrency[productOrder.product.currency]}
                                            </Col>
                                            <Col className="eq-fl-th product-action" span={4}>


                                                <Space>
                                                    <Button
                                                        onClick={() => onAccept(productOrder.id)}
                                                        className="invite-accept-btn"
                                                        size="small"
                                                        shape="circle"
                                                        icon={<CheckOutlined />}
                                                    />
                                                    <Button
                                                        onClick={() => OnReject(productOrder.id)}
                                                        className="invite-reject-btn"
                                                        size="small"
                                                        shape="circle"
                                                        icon={<CloseOutlined />}
                                                    />
                                                </Space>
                                            </Col>
                                        </Row>

                                        <div className="hidden-md">
                                            <EqCollapse
                                                header={
                                                    <Row justify="start" align="middle">
                                                        {multipleSelect &&
                                                            <Col className="" span={2}>
                                                                <Checkbox
                                                                    onChange={() => {
                                                                        handleOnCheck(productOrder);
                                                                    }}
                                                                    checked={productOrder.selected}
                                                                ></Checkbox>
                                                            </Col>
                                                        }
                                                        <Col className="" flex="auto">
                                                            {productOrder?.product.title}
                                                        </Col>
                                                    </Row>
                                                }
                                            >
                                                <>
                                                    <Row className="eq-card-row">
                                                        <Col className="eq-card-col-heading" span={24}>
                                                            {t("student")}
                                                        </Col>
                                                        <Col className="" span={24}>
                                                            {`${productOrder.student.firstName}  ${productOrder.student.lastName}`}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col flex="auto" className="eq-card-divider"></Col>
                                                    </Row>
                                                    <Row className="eq-card-row">
                                                        <Col className="eq-card-col-heading" span={24}>
                                                            {t("title")}
                                                        </Col>
                                                        <Col className="" span={24}>
                                                            {productOrder.product.title}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col flex="auto" className="eq-card-divider"></Col>
                                                    </Row>

                                                    <Row className="eq-card-row">
                                                        <Col className="eq-card-col-heading" span={24}>
                                                            {t("startTime")}
                                                        </Col>
                                                        <Col className="product-status" span={24}>
                                                            {moment(productOrder.product.startTime).format(
                                                                "DD MMMM, YYYY HH:mm"
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col flex="auto" className="eq-card-divider"></Col>
                                                    </Row>
                                                    <Row className="eq-card-row">
                                                        <Col className="eq-card-col-heading" span={24}>
                                                            {t("amount")}
                                                        </Col>
                                                        <Col className="" span={24}>
                                                            {productOrder.product.price}{" "}
                                                            {EqCurrency[productOrder.product.currency]}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col flex="auto" className="eq-card-divider"></Col>
                                                    </Row>
                                                    <Row className="eq-card-row">
                                                        <Col className="eq-card-col-heading" span={24}>
                                                            {t("action")}
                                                        </Col>
                                                        <Col className="product-action" span={24}>

                                                            <Space>
                                                                <Button
                                                                    onClick={() => onAccept(productOrder.id)}
                                                                    className="invite-accept-btn"
                                                                    size="small"
                                                                    shape="circle"
                                                                    icon={<CheckOutlined />}
                                                                />
                                                                <Button
                                                                    onClick={() => OnReject(productOrder.id)}
                                                                    className="invite-reject-btn"
                                                                    size="small"
                                                                    shape="circle"
                                                                    icon={<CloseOutlined />}
                                                                />
                                                            </Space>

                                                        </Col>
                                                    </Row>
                                                </>
                                            </EqCollapse>
                                        </div>
                                    </div>
                                )
                            )}


                        </Row>
                    </RevealList>
                </Col>
            </Row>
        </div>
    );
};

export default RequestWidget;
